var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSushi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 41,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sushi_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m36.51 2.99-13.422 7.12c-1.634-1.063-3.837-1.736-6.36-1.736-5.041 0-8.776 2.57-9.338 5.905v3.937l-6.536 3.3 1.693 3.358 4.843-2.49v3.07l-4.318 1.562 1.284 3.474 35.363-12.968-1.284-3.474-12.371 4.516v-4.285c-.08-.485-.255-.94-.467-1.39l12.605-6.541L36.51 2.99Zm-19.783 9.09c3.173 0 5.602 1.483 5.602 2.778 0 1.296-2.429 2.78-5.602 2.78h-.175a10.93 10.93 0 0 1-.992-.059h-.117c-2.53-.325-4.318-1.606-4.318-2.72 0-1.296 2.429-2.78 5.602-2.78Zm0 1.852c-1.028 0-1.867.412-1.867.926s.839.927 1.867.927c1.029 0 1.867-.413 1.867-.927s-.838-.926-1.867-.926Zm9.337 10.769L10.19 30.606c1.678 1.114 3.925 1.852 6.536 1.852 5.23 0 9.337-3.517 9.337-5.557v-2.2Z",
  fill: "#DC632A"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "sushi_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h41v41H0z"
})))));
export default SvgSushi;